import * as admin from "./admin";
import * as auth from "./auth";
import * as billing from "./billing";
import * as bots from "./bots";
import * as calendar from "./calendar";
import * as clips from "./clips";
import * as coaching from "./coaching";
import * as contactGroups from "./contactGroups";
import * as contacts from "./contacts";
import * as crmRecommendations from "./crmRecommendations";
import * as customVocabulary from "./customVocabulary";
import * as dailyRead from "./dailyRead";
import * as draftEmails from "./draftEmails";
import * as enterpriseSearch from "./enterpriseSearch";
import * as entities from "./entities";
import * as eventGroups from "./eventGroups";
import * as feedback from "./feedback";
import integrations from "./integrations";
import * as integrationSettings from "./integrationSettings";
import * as recommendations from "./recommendations";
import * as reports from "./reports";
import * as schedulingLinks from "./schedulingLinks";
import * as serviceStatus from "./serviceStatus";
import session from "./session";
import * as sessions from "./sessions";
import * as sharingRecommendations from "./sharingRecommendations";
import * as tags from "./tags";
import * as topics from "./topics";
import * as users from "./users";
import workspace from "./workspace";

const ApiClient = {
  admin,
  auth,
  billing,
  bots,
  calendar,
  clips,
  coaching,
  contactGroups,
  contacts,
  crmRecommendations,
  customVocabulary,
  dailyRead,
  draftEmails,
  enterpriseSearch,
  entities,
  eventGroups,
  feedback,
  integrations,
  integrationSettings,
  recommendations,
  reports,
  schedulingLinks,
  serviceStatus,
  session,
  sessions,
  sharingRecommendations,
  tags,
  topics,
  users,
  workspace,
};

export default ApiClient;
